import { render, staticRenderFns } from "./questionDetails.vue?vue&type=template&id=5ce88e9a&scoped=true&"
import script from "./questionDetails.vue?vue&type=script&lang=js&"
export * from "./questionDetails.vue?vue&type=script&lang=js&"
import style0 from "./questionDetails.vue?vue&type=style&index=0&id=5ce88e9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce88e9a",
  null
  
)

export default component.exports